'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _similarItems = require('./mock/similarItems');

var _similarItems2 = require('./remote/similarItems');

var SimilarItems = {
    fetchSimilarItemsById: function fetchSimilarItemsById(params) {
        return __MOCK__ ? _similarItems.SimilarItemsMock.fetchSimilarItemsById(params) : _similarItems2.SimilarItemsRemote.fetchSimilarItemsById(params);
    }
};

exports.default = SimilarItems;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/similarItems.js
// module id = ApaR
// module chunks = 46